import React from 'react';

const ArrowUpRightIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.1673 5.83337L5.83398 14.1667M14.1673 5.83337H6.66732M14.1673 5.83337V13.3334",
      stroke: "#26BA50",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
ArrowUpRightIcon.displayName = "Icons.ArrowUpRightIcon";

export { ArrowUpRightIcon };
//# sourceMappingURL=ArrowUpRightIcon.js.map
